<div>
    <div  *ngFor="let item of errors" style="display: block"  class="invalid-feedback">
        {{item}}
    </div>
    <div *ngIf="customMessage" style="display: block"  class="invalid-feedback">
        {{customMessage}}
    </div>
</div>
